import React from 'react';
import cn from 'classnames';

import CN from './ImageCard.module.scss';

const ImageCard = ({ children, variant, variantReverse, ...extra }) => {
  const componentClasses = cn({
    [CN.component]: true,
    [CN[`${variant}Variant`]]: variant,
    [CN.variantReverse]: variantReverse,
  });

  return (
    <div {...extra} data-bem="ImageCard" className={componentClasses}>
      {children}
    </div>
  );
};

export default ImageCard;
